import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

export interface SidebarState {
  tab: string;
}

const initialState: SidebarState = {
  tab: "Products",
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    goToSidebarTab: (state, action: PayloadAction<any>) => {
      state.tab = action.payload.tab;
    },
  },
});

export const { goToSidebarTab } = sidebarSlice.actions;

export const selectSidebar = (state: RootState) => state.sidebar.tab;

export default sidebarSlice.reducer;
